'use client'
import type {
  Project,
  ProjectTable,
  SupabaseUser,
  TableColumnDefinition,
} from '@/lib/types'
import { createContext, useContext } from 'react'
import type { ColumnDef } from '@tanstack/react-table'
import type { CRUD, CRUDState } from './hooks/useCrud'
import type { SetTableName } from './shared'
import type { PaginationClass } from '@/shared'

type DatabaseContextType = {
  /**
   * 当前选中的表名
   */
  tableName: string
  setTableName: SetTableName

  /**
   * 当前选中的表详细信息
   */
  selectedTable: ProjectTable | null

  /**
   * 当前项目
   */
  project?: Project

  isSupabaseEnabled?: boolean

  /**
   * 用户分页
   */
  usersPagination: PaginationClass

  /**
   * 设置用户分页
   */
  setUsersPagination: (
    pagination: PaginationClass | ((prev: PaginationClass) => PaginationClass),
  ) => void

  /**
   * 用户数据
   */
  usersData: Array<{
    data: any[]
    page: number
    perPage: number
    total: number
  }>

  refetchUsers: any
  refetchTables: any
  selectedTableColumn?: TableColumnDefinition

  /**
   * 表格数据
   */
  normalTableColumns: ColumnDef<any>[]

  /**
   * 用户分页
   */
  normalTablePagination: PaginationClass

  /**
   * 表格数据
   */
  normalTableData: SupabaseUser[]

  tables?: ProjectTable[]
  // 加载状态
  loading: {
    users: boolean
    tables: boolean
    crud: CRUDState
  }

  /**
   * 设置用户分页
   */
  setNormalTablePagination: (
    pagination:
      | Record<string, PaginationClass>
      | ((
          prev: Record<string, PaginationClass>,
        ) => Record<string, PaginationClass>),
  ) => void

  updateProjectTableColumnsToDBAndSyncToStore: (payload: {
    action: 'add' | 'drop' | 'alter'
    columnName: string
    dataType?: string
    oldColumnName?: string
    oldDataType?: string
  }) => Promise<void>
} & { crud: CRUD }

export const DatabaseContext = createContext<DatabaseContextType | undefined>(
  undefined,
)

export function useDatabaseContext() {
  const context = useContext(DatabaseContext)
  if (context === undefined) {
    throw new Error('database context must be used')
  }
  return context
}
